
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { OnboardingData } from '../OnboardingFlow';

interface LastNameStepProps {
  data: OnboardingData;
  updateData: (data: Partial<OnboardingData>) => void;
  onNext: () => void;
  onBack: () => void;
}

const LastNameStep = ({ data, updateData, onNext, onBack }: LastNameStepProps) => {
  const [lastName, setLastName] = useState(data.lastName);

  const handleNext = () => {
    if (lastName.trim()) {
      updateData({ lastName: lastName.trim() });
      onNext();
    }
  };

  return (
    <div className="text-center space-y-8">
      <h2 className="text-2xl font-semibold text-slate-dark font-sans">
        And your last name?
      </h2>
      
      <div className="space-y-6">
        <Input
          type="text"
          placeholder="Enter your last name"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          className="h-14 text-lg rounded-xl border-2 border-slate-soft focus:border-blue-primary transition-colors text-center font-sans"
          autoFocus
          onKeyPress={(e) => e.key === 'Enter' && handleNext()}
        />
        
        <div className="space-y-3">
          <Button
            onClick={handleNext}
            disabled={!lastName.trim()}
            className="w-full h-14 text-lg font-semibold bg-blue-primary hover:bg-blue-light disabled:bg-slate-soft disabled:cursor-not-allowed text-white rounded-xl transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98]"
          >
            Next
          </Button>
          
          <Button
            onClick={onBack}
            variant="ghost"
            className="w-full h-12 text-slate-medium hover:text-slate-dark hover:bg-slate-whisper rounded-xl transition-all duration-300 font-sans"
          >
            Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LastNameStep;
